module.exports = __webpack_public_path__ + "img/identification.7c922269.svg";